import moment from 'moment'

export function formatarHoraLocal(value: string) {
  if (value) {
    return moment
      .utc(String(value), 'HH:mm')

      .local()
      .format('HH:mm')
  }
  return ''
}

// Regra canônica do telefone BR: com mais de 11 dígitos começando com 55, o
// DDI já está lá e sai para exibir. Com 10 ou 11 dígitos o número é nacional
// e nada é removido (55 também é o DDD de Santa Maria/RS).
function removerDDIBrasil(apenasNumeros: string): string {
  return apenasNumeros.length > 11 && apenasNumeros.startsWith('55')
    ? apenasNumeros.slice(2)
    : apenasNumeros
}

// (DD) NNNNN-NNNN para celular, (DD) NNNN-NNNN para fixo. Outros tamanhos
// (digitação em andamento, número estrangeiro) voltam só com os dígitos.
function mascararTelefone(apenasNumeros: string): string {
  if (apenasNumeros.length === 11) {
    return apenasNumeros.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3')
  }

  if (apenasNumeros.length === 10) {
    return apenasNumeros.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3')
  }

  return apenasNumeros
}

export default {
  // getConsultoriaStatusStyle(idStatus) {
  //   if (!idStatus) {
  //     return
  //   }

  //   switch (idStatus) {
  //     case config.CONSULTORIA_AGENDADA:
  //       return { backgroundColor: 'rgb(182, 124, 191)' }

  //     case config.CONSULTORIA_DESISTIU_ATEND:
  //       return { backgroundColor: 'rgb(226, 87, 87)' }

  //     case config.CONSULTORIA_ATEND_PAUSADO:
  //       return { backgroundColor: 'rgb(220, 195, 121)' }

  //     case config.CONSULTORIA_AGUARD_REAGEND:
  //       return { backgroundColor: 'rgb(23, 162, 184)' }

  //     case config.CONSULTORIA_ATEND_FINALIZADO:
  //       return { backgroundColor: 'rgb(113, 187, 130)' }

  //     case config.CONSULTORIA_ATEND_INICIADO:
  //       return { backgroundColor: 'rgb(3, 95, 199)' }

  //     case config.CONSULTORIA_AGUARD_AGEND:
  //       return { backgroundColor: 'rgb(124, 182, 255)' }

  //     case config.CONSULTORIA_AGUARD_PLANTAO:
  //       return { backgroundColor: 'rgb(255, 148, 0)' }

  //     case config.CONSULTORIA_CLIENTE_INATIVO:
  //       return { backgroundColor: 'rgb(255, 50, 70)' }

  //     case config.CONSULTORIA_MATERIAL_CONFERIDO:
  //       return { backgroundColor: 'rgb(171, 88, 88)' }

  //     case config.CONSULTORIA_MATERIAL_RECEBIDO:
  //       return { backgroundColor: 'rgb(190, 126, 126)' }

  //     case config.CONSULTORIA_MATERIAL_CONFERIDO_MAIS:
  //       return {
  //         backgroundColor: '#ffab2f',
  //         color: '#622fbd'
  //       }

  //     case config.CONSULTORIA_MATERIAL_REJEITADO:
  //       return { backgroundColor: 'rgb(220, 126, 126)' }
  //   }
  // },

  // obterPrimeirosCaracteres(texto, qtdCaracteres) {
  //   if (!texto) return ''
  //   if (texto.length > qtdCaracteres) {
  //     return `${texto.slice(0, qtdCaracteres)}...`
  //   }
  //   return texto
  // },
  formatarMoedaInput(value, moeda = 'BRL') {
    if (!value && value !== 0) return ''

    // Garantir que o valor seja uma string
    let stringValue = value.toString()

    // Remover qualquer caractere que não seja dígito
    stringValue = stringValue.replace(/\D/g, '')

    // Converter a string em um número
    const numberValue = parseFloat(stringValue)

    // Ajustar o valor para formatar como moeda
    const formattedValue = numberValue / 100

    if (moeda === 'EUR') {
      return formattedValue.toLocaleString('pt-PT', {
        minimumFractionDigits: 2,
        style: 'currency',
        currency: 'EUR'
      })
    } else {
      return formattedValue.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        style: 'currency',
        currency: 'BRL'
      })
    }
  },
  formatarMoeda(value, moeda) {
    if (value || value === 0) {
      if (moeda == 'EUR') {
        return value.toLocaleString('pt-PT', {
          minimumFractionDigits: 2,
          style: 'currency',
          currency: 'EUR'
        })
      } else {
        return value.toLocaleString('pt-BR', {
          minimumFractionDigits: 2,
          style: 'currency',
          currency: 'BRL'
        })
      }
    }
  },
  removerFormatacaoPreco(precoFormatado) {
    if (!precoFormatado) return 0

    // Remover o símbolo de moeda, espaços e pontos de milhar
    let precoSemFormato = precoFormatado.replace(/[^\d,]/g, '')

    // Substituir a vírgula por um ponto (para lidar com casas decimais no formato BR)
    precoSemFormato = precoSemFormato.replace(',', '.')

    // Converter a string em número
    const precoNumerico = parseFloat(precoSemFormato)

    // Retornar o número
    return isNaN(precoNumerico) ? 0 : precoNumerico
  },
  obterPrimeiroNome(nomeCompleto: string) {
    if (!nomeCompleto) {
      return ''
    }
    const nomePosicao = nomeCompleto.split(' ')[0]
    if (!nomePosicao) {
      return ''
    }
    const primeiraMaiuscula =
      nomePosicao[0].toUpperCase() + nomePosicao.substr(1).toLowerCase()
    return primeiraMaiuscula
  },
  // obterPrimeiroESegundoNome(nomeCompleto) {
  //   const primeiroNome = obterNomePorPosicao(nomeCompleto, 0)
  //   const segundoNome = obterNomePorPosicao(nomeCompleto, 1)
  //   return `${primeiroNome} ${segundoNome}`
  // },
  // obterNomePorPosicao(nomeCompleto: string, posicao: number) {
  //   if (!nomeCompleto) {
  //     return ''
  //   }
  //   const nomePosicao = nomeCompleto.split(' ')[posicao]
  //   if (!nomePosicao) {
  //     return ''
  //   }
  //   const primeiraMaiuscula =
  //     nomePosicao[0].toUpperCase() + nomePosicao.substr(1).toLowerCase()
  //   return primeiraMaiuscula
  // },
  // arrayInsertAtIndex(array, idx, value) {
  //   return [].concat(array.slice(0, idx), value, array.slice(idx))
  // },
  // phoneMask(value: string) {
  //   if (!value) return ''

  //   try {
  //     if (value.startsWith('+')) {
  //       const phoneNumber = parsePhoneNumberFromString(value)
  //       if (phoneNumber && isValidPhoneNumber(value)) {
  //         return phoneNumber.formatInternational()
  //       }
  //       return value
  //     }

  //     const apenasNumeros = value.replace(/\D/g, '')

  //     if (
  //       apenasNumeros.length > 10 &&
  //       (apenasNumeros.startsWith('1') ||
  //         apenasNumeros.startsWith('61') ||
  //         apenasNumeros.startsWith('351') ||
  //         apenasNumeros.startsWith('34') ||
  //         apenasNumeros.startsWith('33'))
  //     ) {
  //       try {
  //         const numeroComPlus = `+${apenasNumeros}`
  //         const phoneNumber = parsePhoneNumberFromString(numeroComPlus)
  //         if (phoneNumber && isValidPhoneNumber(numeroComPlus)) {
  //           return phoneNumber.formatInternational()
  //         }
  //         return numeroComPlus
  //       } catch {
  //         return `+${apenasNumeros}`
  //       }
  //     }

  //     if (apenasNumeros.length === 10 || apenasNumeros.length === 11) {
  //       try {
  //         const numeroComPlus = `+55${apenasNumeros}`
  //         const phoneNumber = parsePhoneNumberFromString(numeroComPlus)
  //         if (phoneNumber && isValidPhoneNumber(numeroComPlus)) {
  //           return phoneNumber.format('NATIONAL')
  //         }
  //       } catch {
  //         console.error('Erro ao formatar número de telefone')
  //       }

  //       return apenasNumeros
  //         .replace(/(\d{2})(\d)/, '($1) $2')
  //         .replace(/(\d)(\d{4})$/, '$1-$2')
  //     }

  //     return apenasNumeros.length > 0 ? `+${apenasNumeros}` : value
  //   } catch {
  //     return value
  //   }
  // },
  phoneMask(value: string): string {
    if (!value) return ''

    return mascararTelefone(removerDDIBrasil(value.replace(/\D/g, '')))
  },
  // Máscara do campo de telefone BR: mesma regra do phoneMask, mas nunca passa
  // de 11 dígitos (DDD + número). Quem cola "+55 11 98318-8812" vê
  // "(11) 98318-8812".
  telefoneBrMask(value: string): string {
    if (!value) return ''

    return mascararTelefone(
      removerDDIBrasil(value.replace(/\D/g, '')).slice(0, 11)
    )
  },
  // Telefone BR para gravar: só dígitos, com o 55 na frente.
  // "(21) 96831-0990" vira "5521968310990". Se já vier com o DDI (12 ou 13
  // dígitos começando com 55), fica como está.
  telefoneBrParaEnvio(value: string): string {
    if (!value) return ''

    const apenasNumeros = value.replace(/\D/g, '')
    if (apenasNumeros.length === 10 || apenasNumeros.length === 11) {
      return `55${apenasNumeros}`
    }

    return apenasNumeros
  },
  dateNascMask(value: string) {
    return value
      .replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
      .replace(/(\d{2})(\d)/, '$1/$2') //Coloca parênteses em volta dos dois primeiros dígitos
      .replace(/(\d{2})(\d)/, '$1/$2') //Coloca hífen entre o quarto e o quinto dígito
  },
  cepMask(value: string) {
    if (!value) return ''
    if (value) {
      return value
        .replace(/\D/g, '') //Remove tudo o que não é dígito
        .replace(/^(\d{5})(\d)/, '$1-$2') //Coloca traço entre o quinto e o sexto dígitos
    }
  },
  cpfMask(value: string) {
    if (!value) return ''

    return value
      .replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
      .replace(/(\d{3})(\d)/, '$1.$2') // captura 2 grupos de numero o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})/, '$1-$2')
      .replace(/(-\d{2})\d+?$/, '$1') // captura 2 numeros seguidos de um traço e não deixa ser digitado mais nada
  },
  // Máscara de CNPJ. Aceita letras nas 12 primeiras posições porque o CNPJ
  // é alfanumérico a partir de julho/2026 (IN RFB 2.229/2024).
  cnpjMask(value: string): string {
    if (!value) return ''

    const limpo = value
      .replace(/[^0-9A-Za-z]/g, '')
      .toUpperCase()
      .slice(0, 14)

    return limpo
      .replace(/^([0-9A-Z]{2})([0-9A-Z])/, '$1.$2')
      .replace(/^([0-9A-Z]{2})\.([0-9A-Z]{3})([0-9A-Z])/, '$1.$2.$3')
      .replace(/\.([0-9A-Z]{3})([0-9A-Z])/, '.$1/$2')
      .replace(/\/([0-9A-Z]{4})([0-9A-Z])/, '/$1-$2')
  },
  documentoMask(value: string): string {
    if (!value) return ''

    const limpo = value.replace(/[^0-9A-Za-z]/g, '')

    if (/^\d{0,11}$/.test(limpo)) {
      return this.cpfMask(value)
    }

    return this.cnpjMask(value)
  },
  revertMask(value: string) {
    return value.replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
  },
  // Versão para documento (CPF/CNPJ): preserva letras porque o CNPJ é
  // alfanumérico nas 12 primeiras posições a partir de julho/2026.
  revertDocumentoMask(value: string) {
    return value.replace(/[^0-9A-Za-z]/g, '').toUpperCase()
  },
  formatarDataLocal(value: string) {
    if (value) {
      return moment.utc(String(value)).local().format('DD/MM/YYYY')
    }
    return ''
  },
  formatarDataHoraLocal(value: string) {
    if (value) {
      return moment.utc(String(value)).local().format('DD/MM/YYYY HH:mm')
    }
    return ''
  },
  converterDataParaISO(dataString) {
    // Dividir a string da data no formato DD/MM/YYYY
    const [dia, mes, ano] = dataString.split('/').map(Number)

    // Criar um objeto Date usando os valores extraídos e a hora atual
    const data = new Date(ano, mes - 1, dia)

    // Obter a hora atual
    const agora = new Date()

    // Atualizar a data com a hora atual
    data.setHours(
      agora.getHours(),
      agora.getMinutes(),
      agora.getSeconds(),
      agora.getMilliseconds()
    )

    // Retornar a data no formato ISO 8601
    return data.toISOString()
  },
  // formatarHoraLocal
  // obterDiaSemana(value) {
  //   if (value) {
  //     return moment.utc(String(value)).local().format('dddd')
  //   }
  //   return ''
  // },
  // groupBy(arrayOfObject, key) {
  //   return arrayOfObject.reduce(function (rv, x) {
  //     ;(rv[x[key]] = rv[x[key]] || []).push(x)
  //     return rv
  //   }, {})
  // },
  // obterExtensaoArquivo(nomeArquivo) {
  //   if (!nomeArquivo) {
  //     return
  //   }

  //   const partesNomeArquivo = nomeArquivo.split('.')
  //   const extensaoArquivo =
  //     '.' + partesNomeArquivo[partesNomeArquivo.length - 1]
  //   return extensaoArquivo
  // },
  // parseNomeCompleto(nomeCompleto) {
  //   let primeiroNome = ''
  //   let restante = ''

  //   if (nomeCompleto) {
  //     const espacoIdx = nomeCompleto.indexOf(' ')

  //     if (espacoIdx >= 0) {
  //       primeiroNome = nomeCompleto.substr(0, espacoIdx)
  //       restante = nomeCompleto.substr(espacoIdx + 1)
  //     } else {
  //       primeiroNome = nomeCompleto
  //     }
  //   }

  //   return {
  //     primeiroNome: primeiroNome,
  //     restante: restante
  //   }
  // },

  // getOptions(itensObj) {
  //   if (!itensObj) {
  //     return []
  //   }

  //   const options = []
  //   for (const key in itensObj) {
  //     options.push({ text: itensObj[key], value: key })
  //   }

  //   return options
  // },

  // getUrlParameter(name) {
  //   name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]')
  //   const regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
  //   const results = regex.exec(location.search || location.hash)
  //   return results === null
  //     ? ''
  //     : decodeURIComponent(results[1].replace(/\+/g, ' '))
  // },

  // obterDescricaoAmbiente(ambienteValue) {
  //   const item = config.LISTA_AMBIENTES.find((i) => i.value == ambienteValue)
  //   return item?.text
  // },

  // obterDescricaoFuncaoArquiteto(idFuncao) {
  //   const item = config.FUNCOES_ARQUITETO.find((i) => i.id == idFuncao)
  //   return item?.descricao
  // },

  // obterCorFuncaoArquiteto(idFuncao) {
  //   const item = config.FUNCOES_ARQUITETO.find((i) => i.id == idFuncao)
  //   return item?.cor
  // }
  documentoValidator(valor: string | undefined): boolean {
    if (!valor) return false

    // Mantém letras: o CNPJ é alfanumérico nas 12 primeiras posições
    // a partir de julho/2026 (IN RFB 2.229/2024).
    const documento = valor.replace(/[^0-9A-Za-z]/g, '').toUpperCase()

    if (/^\d{11}$/.test(documento)) {
      return this.cpfValidator(documento)
    } else if (/^[0-9A-Z]{12}\d{2}$/.test(documento)) {
      return this.cnpjValidator(documento)
    }

    return false
  },

  cpfValidator(cpfComOuSemMascara: string | undefined) {
    if (!cpfComOuSemMascara) {
      return false
    }

    //Extraindo somente os números
    const cpf = cpfComOuSemMascara.replace(/[^0-9]/g, '')

    let numeros, digitos, soma, i, resultado, digitos_iguais
    digitos_iguais = 1
    if (cpf.length < 11) return false
    for (i = 0; i < cpf.length - 1; i++)
      if (cpf.charAt(i) != cpf.charAt(i + 1)) {
        digitos_iguais = 0
        break
      }
    if (!digitos_iguais) {
      numeros = cpf.substring(0, 9)
      digitos = cpf.substring(9)
      soma = 0
      for (i = 10; i > 1; i--) soma += numeros.charAt(10 - i) * i
      resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11)
      if (resultado != digitos.charAt(0)) return false
      numeros = cpf.substring(0, 10)
      soma = 0
      for (i = 11; i > 1; i--) soma += numeros.charAt(11 - i) * i
      resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11)
      if (resultado != digitos.charAt(1)) return false
      return true
    } else return false
  },
  // Pesos do Mod-11 do CNPJ. O slice ajusta para a base de 12 ou 13 posições.
  PESOS_CNPJ: [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2],

  // Calcula um dígito verificador do CNPJ.
  // O valor de cada caractere é o código ASCII menos 48, então '0'-'9' valem
  // 0-9 e 'A'-'Z' valem 17-42 (regra do CNPJ alfanumérico, IN RFB 2.229/2024).
  calcularDVCNPJ(base: string): number {
    const pesos = this.PESOS_CNPJ.slice(this.PESOS_CNPJ.length - base.length)

    let soma = 0
    for (let i = 0; i < base.length; i++) {
      soma += (base.charCodeAt(i) - 48) * pesos[i]
    }

    const resto = soma % 11
    return resto < 2 ? 0 : 11 - resto
  },

  // Valida CNPJ numérico ou alfanumérico: as 12 primeiras posições aceitam
  // [0-9A-Z] e os 2 dígitos verificadores continuam numéricos.
  cnpjValidator(cnpj: string): boolean {
    const limpo = (cnpj || '').replace(/[^0-9A-Za-z]/g, '').toUpperCase()

    if (!/^[0-9A-Z]{12}\d{2}$/.test(limpo)) return false
    if (/^(.)\1{13}$/.test(limpo)) return false // Verifica sequências repetidas

    return (
      this.calcularDVCNPJ(limpo.substring(0, 12)) ===
        Number(limpo.charAt(12)) &&
      this.calcularDVCNPJ(limpo.substring(0, 13)) === Number(limpo.charAt(13))
    )
  },

  normalizeText(text) {
    return text
      .toLowerCase() // Converter para letras minúsculas
      .normalize('NFD') // Normalizar acentos
      .replace(/[\u0300-\u036f]/g, '') // Remover acentos
      .replace(/[^a-z0-9]/g, ' ') // Remover caracteres não alfanuméricos
  }
}
